import React from 'react';
import { translate } from 'react-i18next';
import DatePicker from 'material-ui/DatePicker';
import user from '../Auth/user';
import compose from '../compose';

const DAYINMILLISECONDS = 86400000;

class DateFilter extends React.Component {

  constructor(props) {
    super(props);

    const today = new Date();

    this.state = {
      startDate: new Date(today.getTime() - 30 * DAYINMILLISECONDS),
      endDate: today,
      today,
    };

  }

  componentDidMount = () => {
    if(this.props.updateFunction) {
      this.props.updateFunction(this.state.startDate, this.state.endDate);
    }
    if(this.props.onFilterChange) {
      setTimeout(() => {
        this.updateFilter(this.state.startDate, this.state.endDate);
      }, 1000);
    }

  }

  startDateChanged = (event, startDate) => {
    this.setState({startDate});
    if(this.props.updateFunction) {
      this.props.updateFunction(startDate, this.state.endDate);
    }
    if(this.props.onFilterChange) {
      this.updateFilter(this.state.startDate, this.state.endDate);
    }
  }

  endDateChanged = (event, date) => {
    let endDate = new Date(date.getTime() + DAYINMILLISECONDS - 1);
    this.setState({endDate});
    if(this.props.updateFunction) {
      this.props.updateFunction(this.state.startDate, endDate);
    }
    if(this.props.onFilterChange) {
      this.updateFilter(this.state.startDate, this.state.endDate);
    }
  }

  updateFilter = (startDate, endDate) => {
    this.props.onFilterChange(
      (data) => {
        const date = data[this.props.filterBy];
        if (startDate && endDate) {
          return date >= startDate && date <= endDate;
        } else if (startDate) {
          return date >= startDate;
        } else if (endDate) {
          return date <= endDate;
        } else {
          return true;
        }
      }
    );
  }


  render() {
    const {t, user} = this.props;
    const style = {
      display: 'inline-block',
      float: 'right',
    };

    return (
      <div style={style}>
        <DatePicker
          floatingLabelText={t('startRange')}
          cancelLabel={t('cancel')}
          locale={user.language}
          DateTimeFormat={Intl.DateTimeFormat}
          autoOk={true}
          onChange={this.startDateChanged}
          value={this.state.startDate}
          maxDate={this.state.endDate ? new Date(this.state.endDate) : new Date()}
          style={{display: 'inline-block', marginRight:'20px'}}
        />

        <DatePicker
          floatingLabelText={t('endRange')}
          cancelLabel={t('cancel')}
          locale={user.language}
          DateTimeFormat={Intl.DateTimeFormat}
          autoOk={true}
          onChange={this.endDateChanged}
          minDate={this.state.startDate ? new Date(this.state.startDate) : new Date(1970,1,1)}
          maxDate={this.state.today}
          value={this.state.endDate}
          style={{display: 'inline-block'}}
        />
      </div>
    );
  }
}

const enhance = compose(translate(), user);

export default enhance(DateFilter);



// WEBPACK FOOTER //
// ./src/Dashboard/DateFilter.js